import { combineReducers } from 'redux'

import insertionFeature from '../insertion/insertionFeature'
import addressFeature from '../address/addressFeature'
import multimediaFeature from '../multimedia/multimediaFeature'
import messageFeature from '../message/messageFeature'
import flowFeature from '../flow/flowFeature'
import previewFeature from '../preview/previewFeature'
import suggestedTextFeature from '../suggestedText/suggestedTextFeature'
import priceMaximizerFeature from '../priceMaximizer/priceMaximizerFeature'
import valuationFeature from '../valuation/valuationFeature'
import errorHandlerFeature from '../errorHandler/errorHandlerFeature'
import formStateFeature from '../formState/formStateFeature'
import contactFeature from '../contact/contactFeature'
import userFeature from '../user/userFeature'
import segmentationFeature from '../segmentation/segmentationFeature'

const rootReducer = combineReducers({
  insertionFeature,
  addressFeature,
  formStateFeature,
  multimediaFeature,
  messageFeature,
  flowFeature,
  previewFeature,
  suggestedTextFeature,
  priceMaximizerFeature,
  valuationFeature,
  errorHandlerFeature,
  contactFeature,
  userFeature,
  segmentationFeature,
})
export default rootReducer

export type RootState = ReturnType<typeof rootReducer>
